import {ApplePayPaymentInfoType} from 'types/applePayType';

/**
 * checks and replaces fields in shipping if necessary
 */
export const replaceLostShippingFields = (
    addressData: ApplePayPaymentInfoType,
    names: {
        shippingFirstName: string;
        shippingLastName: string;
        payerNameArray?: string[] | null;
        payerLastName?: string;
        shippingStreet?: string;
    },
) => {
    const {billingAddress, phone, shippingAddress} = addressData;
    const {payerLastName, payerNameArray, shippingFirstName, shippingLastName, shippingStreet} =
        names;

    const requiredShippingKeys = [
        'country',
        'city',
        'phone',
        'postalCode',
        'region',
        'addressLine',
    ] as const;

    const lostKeys = requiredShippingKeys.reduce<string[]>((acc, key) => {
        if (key !== 'addressLine') return shippingAddress[key]?.trim() ? acc : [...acc, key];
        // ',' is the case when join array with two empty strings
        return shippingStreet?.trim() && shippingStreet?.trim() !== ',' ? acc : [...acc, key];
    }, []);

    let shippingLostValues = {};

    const isFullNameSame =
        shippingFirstName === payerNameArray?.[0] && shippingLastName === payerLastName;
    const isFullNameEmpty = !shippingAddress?.recipient?.trim();

    const fieldsReplacers = {
        addressLine: () => ({
            firstName:
                (isFullNameEmpty ? payerNameArray?.[0] : shippingFirstName) || 'FirstNameEmpty',
            lastName: (isFullNameEmpty ? payerLastName : shippingLastName) || 'LastNameEmpty',
            street:
                isFullNameSame || isFullNameEmpty
                    ? [billingAddress?.line1, billingAddress?.line2].filter(Boolean).join(', ') ||
                      'addressLineEmpty'
                    : 'addressLineEmpty',
        }),
        default: (key: string) => ({
            [key]:
                (
                    billingAddress?.[
                        key as keyof ApplePayPaymentInfoType['billingAddress']
                    ] as unknown as string
                )?.trim() || 'fieldIsEmpty',
        }),
        phone: () => ({
            phone,
        }),
        postalCode: () => ({
            postcode: isFullNameSame ? billingAddress?.postal_code?.trim() : 'postCodeEmpty',
        }),
        region: () => ({
            region: isFullNameSame ? billingAddress?.state?.trim() || 'regionEmpty' : 'regionEmpty',
        }),
    };

    lostKeys.forEach(key => {
        shippingLostValues = {
            ...shippingLostValues,
            ...(fieldsReplacers[key as keyof typeof fieldsReplacers]?.(key) ||
                fieldsReplacers.default(key)),
        };
    });

    return shippingLostValues;
};
